import React from "react";

const MONTHS = ["JAN","FEB","MAR","APR","MAY","JUN","JUL","AUG","SEP","OCT","NOV","DEC"];

function MonthRow({ months, accent = "from-emerald-600 to-emerald-700" }) {
  return (
    <div className="grid grid-cols-12 gap-1.5">
      {MONTHS.map((m) => {
        const on = months[m];
        return (
          <div key={m}
            className={`relative aspect-[3/4] rounded-lg flex items-center justify-center text-[10px] font-medium transition
              ${on
                ? `bg-gradient-to-br ${accent} text-white shadow-md shadow-emerald-600/20`
                : "glass-soft text-stone-400"}`}
            title={on ? `${m} — Available` : `${m} — Off-season`}>
            {m.slice(0, 1)}
            {on && <span className="absolute top-1 right-1 w-1 h-1 rounded-full bg-white/40" />}
          </div>
        );
      })}
    </div>
  );
}

export default function AvailabilityChart({
  months,
  byVariety,
  accent = "from-emerald-600 to-emerald-700",
  compact = false,
}) {
  if (byVariety && byVariety.length) {
    return (
      <div className="space-y-4">
        <div className="grid grid-cols-12 gap-1.5">
          {MONTHS.map((m) => (
            <div key={m} className="text-center text-[10px] uppercase tracking-widest text-stone-400">{m.slice(0,1)}</div>
          ))}
        </div>
        {byVariety.map((v) => (
          <div key={v.name}>
            <div className="flex items-center justify-between mb-1.5">
              <div className="text-sm font-medium text-stone-800">{v.name}</div>
              <div className="text-[11px] text-stone-400">
                {Object.values(v.months).filter(Boolean).length} mo
              </div>
            </div>
            <MonthRow months={v.months} accent={accent} />
          </div>
        ))}
      </div>
    );
  }

  return (
    <div>
      {!compact && (
        <div className="grid grid-cols-12 gap-1.5 mb-2">
          {MONTHS.map((m) => (
            <div key={m} className="text-center text-[10px] uppercase tracking-widest text-stone-400">{m.slice(0,3)}</div>
          ))}
        </div>
      )}
      <MonthRow months={months} accent={accent} />
    </div>
  );
}
